import {DATA_HOVER, TOGGLE_COLLAPSED_NAV, TOGGLE_TOP_NAV} from "@/redux/constants/Theme";
import {THEME_CONFIG, ThemeState} from "@/configs/ThemeConfig";

const initTheme = {
    ...THEME_CONFIG
};

// Define the action interface
interface ToggleCollapsedNavAction {
    type: typeof TOGGLE_COLLAPSED_NAV;
    navCollapsed: boolean;
}

interface ToggleTopNavAction {
    type: typeof TOGGLE_TOP_NAV;
    topNavCollapsed: boolean;
}

interface DataHoverAction {
    type: typeof DATA_HOVER;
    dataHover: boolean;
}

type ThemeAction = ToggleCollapsedNavAction | ToggleTopNavAction | DataHoverAction;

export const ThemeReducer = (state = initTheme, action: ThemeAction) : ThemeState => {
    switch (action.type) {
        case TOGGLE_COLLAPSED_NAV:
            return {
                ...state,
                navCollapsed: action.navCollapsed
            };
            
        case TOGGLE_TOP_NAV:
            return {
                ...state,
                topNavCollapsed: action.topNavCollapsed
            };

        case DATA_HOVER:
            return {
                ...state,
                dataHover: action.dataHover
            };

        default:
            return state;
    }
};
